import { TokenUserPermissions } from 'api/users/schemas/Users';
import { DisplayForPermission } from 'components/Permission/DisplayForPermission';
import {
  GraniteButton,
  GraniteButtonProps,
} from 'components/V2/Button/GraniteButton';
import { FC } from 'react';
import { Link } from 'react-router-dom';

interface HomeServiceCardProps extends Pick<GraniteButtonProps, 'variant'> {
  pillarSrc: string;
  pillarAltImg: string;
  content: string;
  to: string;
  buttonContent: string;
  permission: TokenUserPermissions | TokenUserPermissions[];
}

const HomeServiceCard: FC<HomeServiceCardProps> = ({
  pillarAltImg,
  pillarSrc,
  content,
  to,
  variant,
  buttonContent,
  permission,
}) => {
  return (
    <DisplayForPermission permission={permission}>
      <div
        className="flex flex-col justify-between gap-y-2 rounded bg-background-base-surface-2 bg-opacity-70 p-6"
        style={{
          backdropFilter: 'blur(32px)',
          boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
        }}
      >
        <div className="flex flex-col gap-y-4">
          <img
            className="ml-0 mr-auto h-6 w-auto"
            alt={pillarAltImg}
            src={pillarSrc}
          />
          <p className="font-semibold text-content-base-subdued">{content}</p>
        </div>
        <Link to={to}>
          <GraniteButton size="large" variant={variant}>
            {buttonContent}
          </GraniteButton>
        </Link>
      </div>
    </DisplayForPermission>
  );
};

export default HomeServiceCard;
